"use strict";
import { jsx } from "react/jsx-runtime";
export default function PineRoute() {
  return /* @__PURE__ */ jsx("div", {});
}
